import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { GetDictionary } from '../utilities/CommonFunctions';
import { useLocation } from 'react-router-dom'




i18n.use(initReactI18next).init({
    fallbackLng: 'en',
    lng: 'en',
    resources: {
        en: {
            translations: require('./locales/en/translations.json')
        },
        as: {
            translations: require('./locales/as/translations.json')
        }
    },
    dictionary: GetDictionary("1,2,3,4,5,6,7,8,9"),
    ns: ['translations'],
    defaultNS: 'translations'
});

i18n.languages = ['en', 'as'];

export default i18n;